import React from 'react';

const BoligmappaLogoSimple = (props) => (
  <svg
    viewBox="0 0 26.062 21.152"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <style>{`.boligmappaLogoIconClass{fill:none;stroke:currentColor;fill-rule:evenodd;}`}</style>
    </defs>
    <g transform="translate(0.516 0.56)">
      <path
        className="boligmappaLogoIconClass"
        transform="translate(-63.037 -93.702)"
        d="M65.846,113.794H82.423a1.147,1.147,0,0,0,.882-.57l4.463-8.009c.652-1.16.23-2.115-.934-2.115H70.264a1.16,1.16,0,0,0-.886.57l-4.463,8.006c-.649,1.164-.23,2.118.934,2.118"
      />
      <path
        className="boligmappaLogoIconClass"
        transform="translate(-60 -75.77)"
        d="M69.321,76.273l-8.51,6.7a2.111,2.111,0,0,0-.82,1.819v7.4l4.391-7.868a3.055,3.055,0,0,1,2.561-1.555H80.33L72.091,76.28a2.221,2.221,0,0,0-2.774,0"
      />
    </g>
  </svg>
);

export default BoligmappaLogoSimple;
